import {
  fullWidthColumnCss,
  hideRailCss,
  mastheadBandCss,
  matchesBreakpoint,
  moveIdentityInto,
  paneGridCss,
} from '../surface';

import type { ArmSpec } from '../armRegistry';

export const profileMasthead: ArmSpec = {
  stamp: () => ({
    render_state: matchesBreakpoint('wide') ? 'rendered' : 'fallback',
  }),

  onReady: (ctx) => {
    if (!matchesBreakpoint('wide')) return;

    // A failed move leaves only an empty pageTop slot, which takes no layout.
    if (!moveIdentityInto(ctx.mountSlot('pageTop'))) return;

    // Unbanded deliberately: the move above is DOM and no media query can undo
    // it, so banding these rules would strand a resized-narrow viewport with
    // moved DOM and no layout. Unbanded, a resize to narrow keeps the masthead
    // layout — accepted degradation, matching the load-time gate. The grid
    // recipe carries its own band, so that same resize drops the grid while
    // keeping the masthead — the same accepted degradation.
    ctx.injectStyles(
      hideRailCss(ctx.scope) +
        fullWidthColumnCss(ctx.scope) +
        mastheadBandCss(ctx.scope) +
        paneGridCss(ctx.scope, { columns: 2, band: 'wide' }),
    );
    ctx.markRendered();
  },
};
